export const citiesData = [
  {
    id: 1,
    si_no: "",
    select: "",
    city_name: "Gandzasar",
    country_name: "American Samosa(+684)",
    country_image: "assets/img/flags/as.png",
    state_name: "Swains Island",
    Action: "",
	key: "1"
  },
  {
    id: 2,
    si_no: "",
    select: "",
    city_name: "Escaldes-Engordany",
    country_name: "Andorra(+376)",
    country_image: "assets/img/flags/ad.png",
    state_name: "Andorra la Vella",
    Action: "",
	key: "2"
  },
  {
    id: 3,
    si_no: "",
    select: "",
    city_name: "Chissamba",
    country_name: "Angola(+244)",
    country_image: "assets/img/flags/ao.png",
    state_name: "Benguella",
    Action: "",
	key: "3"
  },
  {
    id: 4,
    si_no: "",
    select: "",
    city_name: "Illinois",
    country_name: "Angulila(+1264)",
    country_image: "assets/img/flags/ai.png",
    state_name: "The Valley",
    Action: "",
	key: "4"
  },
  {
    id: 5,
    si_no: "",
    select: "",
    city_name: "Melbourne",
    country_name: "Antartica(+672)",
    country_image: "assets/img/flags/qa.png",
    state_name: "Victoria Land",
    Action: "",
	key: "5"
  },
  {
    id: 6,
    si_no: "",
    select: "",
    city_name: "Maplewood",
    country_name: "Antigua & Barbuda(+1268)",
    country_image: "assets/img/flags/ag.png",
    state_name: "Saint Paul",
    Action: "",
	key: "6"
  },
  {
    id: 7,
    si_no: "",
    select: "",
    city_name: "Rosario",
    country_name: "Argentina(+54)",
    country_image: "assets/img/flags/ar.png",
    state_name: "Santa Fe",
    Action: "",
	key: "7"
  },
  {
    id: 8,
    si_no: "",
    select: "",
    city_name: "Atherton",
    country_name: "Australia(+61)",
    country_image: "assets/img/flags/au.png",
    state_name: "Queensland",
    Action: "",
	key: "8"
  },
  {
    id: 9,
    si_no: "",
    select: "",
    city_name: "Mayrhofen",
    country_name: "Austria(+43)",
    country_image: "assets/img/flags/at.png",
    state_name: "Tyrol",
    Action: "",
	key: "9"
  },
  {
    id: 10,
    si_no: "",
    select: "",
    city_name: "Askeran",
    country_name: "Azerbaijan(+994)",
    country_image: "assets/img/flags/az.png",
    state_name: "Karabakh",
    Action: "",
	key: "10"
  },
];
